import { Button } from "primereact/button";
import React from "react";
import { T } from "services/lang/LanguageService";
import { downloadStringAsFile } from "utils/file-utils";

interface SimpleJsonExportButtonProps {
  data: any;
  filename?: string;
  label?: string;
}

const SimpleJsonExportButton = ({ data, filename, label }: SimpleJsonExportButtonProps) => {
  const tempData = typeof data === "string" ? data : JSON.stringify(data);
  return (
    <Button
      icon="pi pi-file-export"
      label={label ?? T("action.export-data")}
      className="component-editor-button icon-green"
      onClick={() => downloadStringAsFile(tempData, filename ?? "data.json")}
    />
  );
};

export default SimpleJsonExportButton;
